/**
 * Controles Titolin — utilitários UI (senha toggle, aria-busy loading)
 */
(function () {
  // Toggle olho em campos de senha (login/cadastro)
  document.querySelectorAll('[data-tt-password-toggle]').forEach((btn) => {
    const inputId = btn.getAttribute('aria-controls');
    const input = document.getElementById(inputId);
    if (!input) return;

    btn.addEventListener('click', () => {
      const isHidden = input.type === 'password';
      input.type = isHidden ? 'text' : 'password';
      btn.setAttribute('aria-pressed', String(isHidden));
      btn.setAttribute('aria-label', isHidden ? 'Ocultar senha' : 'Mostrar senha');
    });
  });

  // Mantém largura do botão em loading (aria-busy)
  document.querySelectorAll('.button.loading, .button[aria-busy="true"]').forEach((btn) => {
    if (!btn.dataset.ttWidth) {
      btn.dataset.ttWidth = btn.offsetWidth + 'px';
      btn.style.minWidth = btn.dataset.ttWidth;
    }
  });

  // Renomeia rótulos de filtro ES → PT-BR (Search & Discovery / admin)
  var FILTER_LABELS = {
    Disponibilidad: 'Disponibilidade',
    Precio: 'Preço',
    Availability: 'Disponibilidade',
    Price: 'Preço',
  };

  // Corrige typo gerado por replace parcial antigo
  var FILTER_FIXES = {
    Disponibilidadee: 'Disponibilidade',
  };

  function renameFilterLabels(root) {
    var scope = root || document;
    var walker = document.createTreeWalker(scope.body || scope, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentElement;
      if (!parent) continue;
      if (!parent.closest('.facets__summary, .mobile-facets__summary, .facets__heading, .active-facets, .mobile-facets__close-button, .mobile-facets__heading')) continue;
      var raw = node.textContent || '';
      var trimmed = raw.trim();
      if (FILTER_FIXES[trimmed]) {
        node.textContent = raw.replace(trimmed, FILTER_FIXES[trimmed]);
        continue;
      }
      if (!FILTER_LABELS[trimmed]) continue;
      // Match exacto do rótulo (evita Disponibilidade → Disponibilidadee)
      node.textContent = raw.replace(trimmed, FILTER_LABELS[trimmed]);
    }
    scope.querySelectorAll('button.facets__summary, summary.facets__summary, .mobile-facets__close-button').forEach(function (btn) {
      var label = btn.getAttribute('aria-label');
      if (!label) return;
      Object.keys(FILTER_FIXES).forEach(function (from) {
        if (label.indexOf(from) !== -1) btn.setAttribute('aria-label', label.replace(from, FILTER_FIXES[from]));
      });
      Object.keys(FILTER_LABELS).forEach(function (from) {
        if (label === from || label.indexOf(from + ' ') === 0) {
          btn.setAttribute('aria-label', label.replace(from, FILTER_LABELS[from]));
        }
      });
    });
  }

  // Remove sufixo "BRL" dos preços na busca (visual)
  function cleanSearchPrices(root) {
    var scope = root || document;
    if (!scope.querySelector || !scope.querySelector('.template-search')) return;
    scope.querySelectorAll('.template-search .price-item').forEach(function (el) {
      if (el.dataset.ttPriceClean) return;
      var txt = el.textContent || '';
      if (/\sBRL\b/.test(txt)) {
        el.textContent = txt.replace(/\sBRL\b/g, '').trim();
        el.dataset.ttPriceClean = '1';
      }
    });
  }

  function enhanceSearchPage() {
    renameFilterLabels(document);
    cleanSearchPrices(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceSearchPage);
  } else {
    enhanceSearchPage();
  }

  document.addEventListener('shopify:section:load', enhanceSearchPage);
  var observeRoots = [
    document.getElementById('ProductGridContainer'),
    document.getElementById('product-grid'),
    document.getElementById('FacetsWrapperMobile'),
    document.getElementById('main-collection-filters'),
  ].filter(Boolean);
  observeRoots.forEach(function (root) {
    new MutationObserver(enhanceSearchPage).observe(root, { childList: true, subtree: true });
  });
  // Re-aplica rótulos ao abrir submenus do drawer
  document.addEventListener('click', function () {
    window.setTimeout(enhanceSearchPage, 50);
  });
})();
